import { mockAwareFetch } from "./transport";
import type { AppNotification } from "@/stores/notificationsStore";

// Same shapes as the patient notification endpoints (see patient/api/notificationsApi.ts),
// audience CLINICIAN only. The mark-read paths mirror the patient ones under /api/clinician.

interface NotificationListResponse {
  data: AppNotification[];
  unreadCount: number;
}

export async function listClinicianNotificationsApi() {
  const { data, error } = await mockAwareFetch<NotificationListResponse>("/api/clinician/notifications", { method: "GET", portal: "clinician" });
  return { data, error: error?.message ?? null };
}

export async function markClinicianNotificationReadApi(id: string) {
  const { data, error } = await mockAwareFetch<{ message?: string }>(`/api/clinician/notifications/${id}/read`, { method: "POST", portal: "clinician" });
  return { data, error: error?.message ?? null };
}

export async function markAllClinicianNotificationsReadApi() {
  const { data, error } = await mockAwareFetch<{ message?: string }>("/api/clinician/notifications/read-all", { method: "POST", portal: "clinician" });
  return { data, error: error?.message ?? null };
}

/** GET /api/clinician/notifications/unread-count. The bell itself counts the
 *  allowlisted unread items from the list, so nothing calls this yet. */
export async function getClinicianUnreadCountApi() {
  const { data, error } = await mockAwareFetch<{ unreadCount: number }>("/api/clinician/notifications/unread-count", { method: "GET", portal: "clinician" });
  return { data, error: error?.message ?? null };
}
